<i18n>
{
	"no": {
		"externalCode": "Ekstern kode",
		"internalCode": "Intern kode"
	},
	"en": {
		"externalCode": "External code",
		"internalCode": "internal code"
	}
}

</i18n>
<template>
	<div class="flex-container">
		<div style="height: 50px; background: #fff; padding: 0px 15px; display: flex; align-items: center; justify-content: space-between;">
			<t-panel-header
				icon="import"
				type="bp"
				:text="value.name"
			/>
			<t-icon-button
				icon="plus"
				type="bp"
				appearance="minimal"
				@click="addLine"
			/>
		</div>
		<t-grid
			ref="table"
			:key="'natureOfCargoGridKeyTT'"
			style="width:100%; 	overflow-x: hidden;"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			selectable
			:items="value.codelist"
			@selected="onSelected"
		>
			<template v-slot:internalCode="{  item }">
				<t-text-input v-model="item.internalCode"/>
			</template>

			<template v-slot:externalCode="{  item }">
				<t-text-input v-model="item.externalCode"/>
			</template>

			<template v-slot:action="{  item }">
				<t-button
					appearance="minimal"
					type="bp"
					disabled
					intent="danger"
					iconBefore="trash"
				/>
			</template>

		</t-grid>
	</div>

</template>

<script>

import { newUUID } from '@/core';

export default {
	name: 'ManageCodelist',
	props: {
		value: Object
	},
	data() {
		return {
			columnDefinitions: [
				{
					field: 'internalCode',
					displayName: this.$t('internalCode'),
					resizable: true,
				},
				{
					field: 'externalCode',
					displayName: this.$t('externalCode'),
					resizable: true,
				},{
					field: 'action',
					displayName: '',
					width: 100
				}
			],
			defaultColumnDefinition: { resizable: true },
			selectedIds: []
		};
	},

	created() {
		window.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyDown);
	},
	methods: {
		addLine() {
			this.value.codelist.push({ id: newUUID(), externalCode: '', internalCode: '' });
		},

		onKeyDown(event) {
			if (event.ctrlKey && event.key === 'Delete') {
				for (let item of this.$refs.table.getSelectedItems()) {
					this.removeCodeListItem(item);
				}
			}
		},
		removeCodeListItem(obj) {
			let index = this.value.codelist.findIndex(x => x.id === obj.id);
			this.value.codelist.splice(index, 1);
		},
		onSelected(ids) {
			this.selectedIds = ids;
		}

	}
};
</script>

<style lang="scss" scoped>

.flex-container{
	display:flex;
	height: 100%;
	flex-direction: column;
	background-color: inherit;
	overflow-x: hidden;

}

</style>